import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { RestrictionOptionsMap } from "../../../../common/constants/civic.constants";
import { RestrictionLocationOptions } from "../../../../common/enums/civic.enum";
import { ICreateClubWizardForm } from "../../../../common/interfaces/clubs-wizard.interface";
import { gatewayStore } from "../../../../contexts/gatewayStore";
import "./MembershipVerificationStep.scss";

const MembershipVerificationStep: FC = () => {
  const { values } = useFormikContext<ICreateClubWizardForm>();
  const { gatekeeperNetwork, setGatekeeperNetwork } = gatewayStore();

  useEffect(() => {
    setGatekeeperNetwork(
      RestrictionOptionsMap[
        values.eligibleLocation === RestrictionLocationOptions.OnlyUS
          ? RestrictionLocationOptions.OnlyUS
          : RestrictionLocationOptions.ProhibitUS
      ].gatekeeperNetwork
    );
  }, [setGatekeeperNetwork, values.eligibleLocation]);

  return (
    <>
      <div className="membership-verification__modal">
        <h2 className="membership-verification__modal-title">
          Verification required
        </h2>
        <p className="membership-verification__modal-description">
          To join this club you will need to go through identity verification
          since this club has set specific rules for who can join the club. Now
          you will be redirected to the Civic’s registration page to verify your
          identity.
        </p>
        <p className="membership-verification__modal-description">
          Once you’re done, you will be able to join this club or you will be
          notified in case you don't fulfill one or more membership restrictions
          rules).
        </p>
        {values.eligibleLocation ===
          RestrictionLocationOptions.AllCountries && (
          <>
            <hr />
            <div className="membership-restriction__wrapper-location">
              <div
                onClick={() =>
                  setGatekeeperNetwork(
                    RestrictionOptionsMap[RestrictionLocationOptions.OnlyUS]
                      .gatekeeperNetwork
                  )
                }
                className={`membership-restriction__item ${
                  gatekeeperNetwork.toString() ===
                    RestrictionOptionsMap[
                      RestrictionLocationOptions.OnlyUS
                    ].gatekeeperNetwork.toString() &&
                  `membership-restriction__item--active`
                }`}
              >
                <div className="membership-restriction__text">
                  <p className="membership-restriction__status-label">
                    I am US citizen
                  </p>
                </div>
              </div>
              <div
                onClick={() =>
                  setGatekeeperNetwork(
                    RestrictionOptionsMap[RestrictionLocationOptions.ProhibitUS]
                      .gatekeeperNetwork
                  )
                }
                className={`membership-restriction__item ${
                  gatekeeperNetwork.toString() ===
                    RestrictionOptionsMap[
                      RestrictionLocationOptions.ProhibitUS
                    ].gatekeeperNetwork.toString() &&
                  `membership-restriction__item--active`
                }`}
              >
                <div className="membership-restriction__text">
                  <p className="membership-restriction__status-label">
                    I am not US citizen
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
        <hr />
        <div className="membership-verification__modal-badges">
          <p className="membership-verification__modal-description">
            Membership restrictions
          </p>
          <div className="membership-verification__modal-badge-wrapper">
            <div className="membership-verification__modal-badge-wrapper__badge">
              Verified
            </div>
            <div className="membership-verification__modal-badge-wrapper__badge">
              {RestrictionOptionsMap[values.eligibleLocation].label}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </>
  );
};

export default MembershipVerificationStep;
